export default function BuyAgainModel(dict) {
    this.nameTh = dict.NameTH;
    this.nameEn = dict.NameEN;
    this.id = dict.CampaignId;
    this.originalPrice = dict.OriginalPrice;
    this.pricePerUnit = dict.PricePerUnit;
    this.createDate = dict.CreateDate;
    this.discount = dict.Discount;

    // fullImageUrl เขาไม่ได้ใส่ type large มาให้ ต้องใส่เอง
    this.fullImageUrl = dict.FullImageUrl;
    if (this.fullImageUrl) {
        if (this.fullImageUrl.indexOf("-large") < 0) {
            var newString = this.fullImageUrl.replace("?", "-large?");
            this.fullImageUrl = newString;
        }
    }
}

